export default __webpack_public_path__ + "static/media/time-icon.286226e6.svg";